export default (value) => !!value;
